import { useLang } from "../../context/LanguageContext";
import { HeroDiagram } from "../diagrams/HeroDiagram";
import { ArrowRight } from "lucide-react";

export const Hero = () => {
  const { t } = useLang();
  return (
    <section id="top" data-testid="hero-section" className="relative pt-28 lg:pt-36 pb-24 lg:pb-32 border-b border-[#0B1F3A]/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-12 gap-6 lg:gap-12 items-center">
        <div className="col-span-12 lg:col-span-6 fade-up">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-8 h-px bg-[#D4AF37]" />
            <span className="overline">{t.hero.eyebrow}</span>
          </div>
          <h1 className="font-display font-light text-[#0B1F3A] text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            {t.hero.title.split("™")[0]}
            <span className="text-[#D4AF37] font-medium">™</span>
          </h1>
          <p className="mt-6 text-base lg:text-lg text-[#0B1F3A]/75 leading-relaxed max-w-xl font-['Inter']">
            {t.hero.sub}
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-3">
            <a
              href="#contact"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center gap-2 px-5 py-3 bg-[#0B1F3A] text-white text-sm font-semibold tracking-wide hover:bg-[#0B1F3A]/90 transition-colors border border-[#0B1F3A]"
            >
              {t.hero.primary}
              <ArrowRight size={16} strokeWidth={1.5} className="group-hover:translate-x-0.5 transition-transform" />
            </a>
            <a
              href="#solutions"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center gap-2 px-5 py-3 border border-[#0B1F3A]/30 text-[#0B1F3A] text-sm font-semibold tracking-wide hover:border-[#0B1F3A] transition-colors"
            >
              {t.hero.secondary}
            </a>
          </div>

          <div className="mt-12 pt-6 border-t border-[#0B1F3A]/10 grid grid-cols-3 gap-6 max-w-md">
            <Metric label="Solution Pillars" value="08" />
            <Metric label="Industry Blueprints" value="04" />
            <Metric label="OS Layers" value="06" />
          </div>
        </div>

        <div className="col-span-12 lg:col-span-6 flex justify-center lg:justify-end fade-up">
          <HeroDiagram title="MaxSolution™" subtitle={t.hero.diagramSubtitle} />
        </div>
      </div>
    </section>
  );
};

const Metric = ({ label, value }) => (
  <div>
    <div className="font-display text-2xl font-light text-[#0B1F3A]">{value}</div>
    <div className="mt-1 text-[10px] uppercase tracking-[0.18em] text-[#0B1F3A]/60 font-semibold">{label}</div>
  </div>
);
